// extracted by mini-css-extract-plugin
export default {"container":"PermissionSection_container__NV5Lb","permissionsList":"PermissionSection_permissionsList__PCVSg"};